import { Navigate, Route } from 'react-router-dom';
import DrumAppRoot from './shared/components/DrumAppRoot';
import AppShellLayout from './shared/components/AppShellLayout';

import IntroLogin from './introLogin/IntroLogin';
import DrumGame from './main/drumgame/DrumGame';
// import SongDetail from './songDetail/SongDetail.tsx.disabled';
import Preparation from './main/common/Preparation';
import Gameplay from './main/drumgame/gameplay/Gameplay';
import Results from './main/common/Results';
import Cognitive from './main/cognitive/Cognitive';
import CognitiveGame from './main/cognitive/cognitiveGame/CognitiveGame';
import Records from './main/records/Records';
import Subscription from './subscription/Subscription';
import ProfileRoutes from './profile/ProfileRoutes';


const drumRoutes = (
  <Route path="/drum" element={<DrumAppRoot />}>
    <Route index element={<Navigate to="library" replace />} />
    <Route path="login" element={<IntroLogin />} />
    <Route path="preparation" element={<Preparation />} />
    <Route path="game" element={<Gameplay />} />
    <Route path="cognitive-game" element={<CognitiveGame />} />

    <Route element={<AppShellLayout />}>
      <Route path="library" element={<DrumGame />} />
      {/* <Route path="song-detail" element={<SongDetail />} /> */}
      <Route path="cognitive" element={<Cognitive />} />
      <Route path="records" element={<Records />} />
      <Route path="subscription" element={<Subscription />} />
      <Route path="results" element={<Results />} />
      
      <Route path="profile/*" element={<ProfileRoutes />} />
    </Route>
  </Route>
);

export default drumRoutes;
